export enum AppColors {
  GREEN_PRIMARY = "#2F443B",
  SECONDARY = "#DFBF89",
  PURPLE = "#8B85CA",
  YELLOW_SECONDARY = "#D0AF21",
  YELLOW_ALT = "#DEBE88",
  GREEN_SECONDARY = "#908C13",
  LIGHT_GREEN_TEXT = "#2E453D",
  BROWN_TERRA = "#C8A977",
  WHITE_SECONDARY = "#FAFAFA",
  WHITE_BORDER_1 = "#E2E8F0",
  GRAY_BORDER_1 = "#718096",
  GRAY_TEXT = "#4A5568",
  GRAY_ICON = "#CBD5E0",
  LIGHT_GRAY_TEXT = "#A0AEC0",
  BLACK_TEXT_SECONDARY = "#1A202C",
  BLUE_TEXT = "#40A9FF",
  LIGHT_BLUE = "#BEE3F8",
  LIGHT_BLUE_ALT = "#E6F7FF",
  BACKGROUND_SECONDARY = "#F4F4F5",
  RED_ICON = "#9B2C2C",
  RED_ICON_ALT = "#D70000",
  GREEN_ICON = "#276749",
  SCROLL_BG = "#7B7575",
  LIGHT_GREEN = "#34A853",
  REQUIRED = "#F87171",
  ERROR_TEXT = "#E53E3E",
  BLUE_BACKGROUND_2 = "#DBEAFE",
  ORANGE_TEXT_1 = "#92310A",
  ERROR_TYPE_2 = "#EF4444",
  GRAY_BG = "#8E8E8E",
  GRAY_TEXT_ALT = "#71717A",
  GRAY_TEXT_PLACEHOLDER = "#8E8E8EEB",
  GRAY_BUTTON_BG = "#EDF2F7",
  RED_BUTTON_ALT = "#C53030",

  WARNING_BG = "#FEEBCB",
  WARNING_ICON = "#DD6B20",

  BLACK_BUTTON = "#18181B"
}
